export enum PointAction {
    OPEN_BARRIER = 'open',
    CLOSE_BARRIER = 'close',
}

export enum PointActionType {
    NORMAL = 'normal',
    EMERGENCY = 'emergency',
}

export enum PointType {
    EXIT = 'exit',
    ENTRY = 'entry',
}

export type Point = {
    camera_id: string;
    camera_number: number;
    id: string;
    name: string;
    parking_id: string;
    type: PointType;
};

export type Reason = {
    id: string;
    use_for: PointType;
    description: string;
};

export type PointsGroup = {
    id: string;
    name: string;
    points: string[];
};
